import CiiCalculationResultData from "./data";

export default function mapCiiCalculationResultDataFromJson(json) {
    return new CiiCalculationResultData(
        json['cii'],
        json['distance'],
        json['avg_laden_me_foc'],
        json['avg_ballast_me_foc']
    )
}